import React from "react";
import { Check } from "lucide-react";
import { WHAT_YOU_GET, INTRO_VIDEO, BEFORE_AFTER, OFFER } from "../mock";
import { CtaButton, Reveal, SectionEyebrow } from "./common";
import { VideoCard } from "./VideoCard";

export const WhatYouGet = () => (
  <section className="bg-brand-cream/50 py-20">
    <div className="mx-auto grid max-w-6xl grid-cols-1 items-center gap-12 px-5 md:px-8 lg:grid-cols-2">
      <Reveal>
        <div className="overflow-hidden rounded-3xl shadow-[0_30px_70px_-35px_rgba(35,35,32,0.5)]">
          <img src={WHAT_YOU_GET.image} alt="Non-surgical face lift treatment" className="h-[420px] w-full object-cover" />
        </div>
      </Reveal>
      <Reveal delay={100}>
        <SectionEyebrow>What you get for ${OFFER.price}</SectionEyebrow>
        <h2 className="mt-4 font-serif text-3xl leading-tight text-brand-ink md:text-4xl">
          {WHAT_YOU_GET.title}
        </h2>
        <ul className="mt-6 space-y-3">
          {WHAT_YOU_GET.bullets.map((b) => (
            <li key={b} className="flex items-start gap-3">
              <span className="mt-0.5 flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full bg-brand-sage">
                <Check size={13} className="text-white" />
              </span>
              <span className="font-sans text-[15px] text-brand-ink">{b}</span>
            </li>
          ))}
        </ul>
        <CtaButton className="mt-8" toForm>Claim My Spot</CtaButton>
      </Reveal>
    </div>
  </section>
);

export const IntroVideo = () => (
  <section className="bg-brand-ivory py-20">
    <div className="mx-auto max-w-3xl px-5 text-center md:px-8">
      <Reveal>
        <SectionEyebrow center>See It For Yourself</SectionEyebrow>
        <h2 className="mt-4 font-serif text-3xl text-brand-ink md:text-4xl">
          A quick word from inside the medspa
        </h2>
      </Reveal>
      <Reveal delay={120} className="mt-8">
        <VideoCard poster={INTRO_VIDEO.poster} youtubeId={INTRO_VIDEO.youtubeId} videoUrl={INTRO_VIDEO.videoUrl} aspect="aspect-video" badge="Tap for sound" />
      </Reveal>
      <Reveal delay={180} className="mt-8">
        <CtaButton toForm>Claim My Spot</CtaButton>
      </Reveal>
    </div>
  </section>
);

export const BeforeAfter = () => (
  <section className="bg-brand-cream/50 py-20">
    <div className="mx-auto max-w-6xl px-5 md:px-8">
      <Reveal className="text-center">
        <SectionEyebrow center>Before &amp; After</SectionEyebrow>
        <h2 className="mt-4 font-serif text-3xl text-brand-ink md:text-4xl">Real clients, real results</h2>
        <p className="mx-auto mt-3 max-w-xl font-sans text-sm text-brand-muted">
          Results our clients typically see across a short custom series. Individual results vary.
        </p>
      </Reveal>
      <div className="mt-10 grid grid-cols-1 gap-6 md:grid-cols-2">
        {BEFORE_AFTER.map((item, i) => (
          <Reveal key={i} delay={(i % 2) * 90}>
            <div className="group overflow-hidden rounded-2xl bg-white shadow-[0_18px_50px_-25px_rgba(35,35,32,0.5)] ring-1 ring-brand-cream">
              <div className="relative overflow-hidden">
                <img src={item.src} alt={`Before and after — ${item.name}`} className="w-full object-cover transition-transform duration-700 group-hover:scale-[1.03]" />
                <div className="pointer-events-none absolute inset-x-0 top-0 flex justify-between px-3 py-2">
                  <span className="rounded-full bg-brand-ink/60 px-3 py-1 font-sans text-[10px] font-semibold uppercase tracking-wider text-white backdrop-blur">Before</span>
                  <span className="rounded-full bg-brand-sage/80 px-3 py-1 font-sans text-[10px] font-semibold uppercase tracking-wider text-white backdrop-blur">After</span>
                </div>
              </div>
              <div className="flex items-center justify-between px-5 py-3.5">
                <p className="font-serif text-lg text-brand-ink">{item.name}</p>
                <p className="font-sans text-xs uppercase tracking-[0.14em] text-brand-golddark">Verified client</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
      <div className="mt-10 text-center">
        <CtaButton toForm>Claim My Spot</CtaButton>
      </div>
    </div>
  </section>
);
